import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';

import './App.css';

import useScrollToTop from './hooks/ui/useScrollToTop';

import LandingPage from './pages/LandingPage';
import SchedulePage from './pages/SchedulePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SupportPage from './pages/SupportPage';
import LinkDevicesPage from './pages/LinkDevicesPage';
import AppPage from './pages/AppPage';
import GetAppPage from './pages/GetAppPage';
import NotFoundPage from './pages/NotFoundPage';

function AppRoutes() {
  useScrollToTop();

  useEffect(() => {
    document.body.setAttribute('data-seo-ready', 'true');
    document.dispatchEvent(new Event('render-event'));
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="s" element={<SchedulePage />} />
        <Route path="s/:roomId" element={<SchedulePage />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<TermsOfService />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="help" element={<SupportPage />} />
        <Route path="link-devices" element={<LinkDevicesPage />} />
        <Route path="app" element={<AppPage />} />
        <Route path="get-app" element={<GetAppPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster
        containerClassName="toaster-wrapper"
        position="top-right"
        toastOptions={{ duration: 2000 }}
      />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

export default App;
